/**
 * Убирает из строки html-теги
 *
 * @param {*} str - строка
 * @returns
 */
function stripHtml(str) {
  if (str === null || str === '') { return str; }

  let stripStr = str.toString();

  return stripStr.replace(/(<([^>]+)>)/ig, '');
}

export default stripHtml;
